<template>
  <div class="page-apply dm-corp-page">
    <header-topbar />

    <div class="main-container m-container">
      <h3 class="m-title" v-if="step < 3">填写试用申请</h3>
      <section class="m-step" v-if="step < 3">
        <steps :active="step" />
      </section>

      <section class="m-form">
        <!-- 学校信息 -->
        <el-form
          key="schoolForm"
          v-show="step === 0"
          ref="schoolForm"
          label-position="top"
          :model="schoolForm"
          :rules="schoolRules"
        >
          <el-form-item label="学校全称" prop="school_name">
            <el-input type="text" :maxlength="50" v-model="schoolForm.school_name"></el-input>
          </el-form-item>

          <el-form-item label="学校类型" prop="school_type">
            <el-select class="block" v-model="schoolForm.school_type" placeholder="请选择">
              <el-option
                v-for="item in schoolTypes"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="师生总人数" prop="school_student_num">
            <el-select class="block" v-model="schoolForm.school_student_num" placeholder="请选择">
              <el-option
                v-for="item in schoolScale"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="地址" prop="area_id">
            <el-cascader
              class="block"
              :props="areaProps"
              v-model="schoolForm.area_id"
            ></el-cascader>
          </el-form-item>

          <el-form-item label="是否配有专职心理教师" prop="enable_test">
            <div style="line-height: 30px">
              <el-radio v-model="schoolForm.enable_test" :label="1">是</el-radio>
              <br />
              <el-radio v-model="schoolForm.enable_test" :label="0">否</el-radio>
            </div>
          </el-form-item>

          <el-form-item label="是否配有心理服务场地" prop="enable_consult">
            <div style="line-height: 30px">
              <el-radio v-model="schoolForm.enable_consult" :label="1">是</el-radio>
              <br />
              <el-radio v-model="schoolForm.enable_consult" :label="0">否</el-radio>
            </div>
          </el-form-item>

          <el-form-item label="">
            <div class="m-btns">
              <el-button @click="gotoBack">取消</el-button>
              <el-button type="primary" @click="submitSchoolForm('schoolForm')">下一步</el-button>
            </div>
          </el-form-item>
        </el-form>

        <!-- 设置管理员 -->
        <el-form
          key="adminForm"
          v-show="step === 1"
          ref="adminForm"
          label-position="top"
          :model="adminForm"
          :rules="adminRules"
        >
          <el-form-item label="">
            <p class="top-msg">请设置系统管理员账号信息，用于登录系统的管理后台。</p>
          </el-form-item>

          <el-form-item label="账号名" prop="admin_name">
            <el-input
              type="text"
              :maxlength="20"
              v-model="adminForm.admin_name"
              placeholder="用于登录账号，支持中文，您可填写您的姓名"
            ></el-input>
          </el-form-item>

          <el-form-item label="密码" prop="admin_password">
            <el-input
              type="text"
              :maxlength="20"
              v-model="adminForm.admin_password"
              placeholder="请设置你的登录密码"
            ></el-input>
          </el-form-item>

          <el-form-item label="手机号" prop="admin_phone">
            <el-input
              type="text"
              :maxlength="20"
              v-model="adminForm.admin_phone"
              placeholder="填写手机号后，亦可使用手机号登录系统"
            ></el-input>
          </el-form-item>

          <el-form-item label="">
            <div class="m-btns">
              <el-button @click="setStep(-1)">上一步</el-button>
              <el-button type="primary" @click="submitAdminForm('adminForm')">下一步</el-button>
            </div>
          </el-form-item>
        </el-form>

        <!-- 系统配置 -->
        <el-form
          key="systemForm"
          v-show="step === 2"
          ref="systemForm"
          label-position="top"
          :model="systemForm"
          :rules="systemRules"
        >
          <el-form-item label="">
            <p class="top-msg">填写以下信息，以便于我们为您完成系统配置。</p>
          </el-form-item>

          <el-form-item prop="enable_roles">
            <span slot="label">测评对象 <font style="color: #999">（可多选）</font></span>
            <el-checkbox-group v-model="systemForm.enable_roles">
              <el-checkbox label="student">学生</el-checkbox>
              <el-checkbox label="teacher">教师</el-checkbox>
              <el-checkbox label="parent">家长</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <!--<el-form-item label="登录网址" prop="channel_code">
            <el-input
              class="url-input"
              type="text"
              :maxlength="20"
              v-model="systemForm.channel_code"
            ></el-input>
            <span>.biz.diggmind.com</span>
          </el-form-item>-->

          <el-form-item label="">
            <p class="item-tip">
              根据您的学校名称，我们已为您自动生成一个登录网址的前缀，您可以进行修改，注意只能填写英文小写字母。
            </p>
          </el-form-item>

          <el-form-item v-show="schoolForm.school_type" class="framework" label="架构设置">
            <Framework ref="framework" :type="schoolForm.school_type" />
          </el-form-item>

          <el-form-item label="">
            <div class="m-btns">
              <el-button @click="setStep(-1)">上一步</el-button>
              <el-button type="primary" @click="submitSystemForm('systemForm')">完成</el-button>
            </div>
          </el-form-item>
        </el-form>

        <!-- 联系方式 -->
        <el-form
          key="contactForm"
          v-show="step === 3"
          ref="contactForm"
          label-position="top"
          :model="contactForm"
          :rules="contactRules"
        >
          <el-form-item label="">
            <div class="thank-item">
              <i class="dmico-trial-success"></i>
              <h2>感谢您的试用申请</h2>
            </div>
          </el-form-item>

          <el-form-item label="">
            <div class="thank-item">
              <p>
                我们将马上对您的申请进行人工审核，过程中我们的工作人员需要向您致电，以进行资料核实，因此请完善以下信息。
              </p>
            </div>
          </el-form-item>

          <!--<el-form-item label="常用手机号" prop="contact_phone">
            <el-input
              type="text"
              v-model="contactForm.contact_phone"
              placeholder="请填写常用手机号"
            ></el-input>
          </el-form-item>-->

          <el-form-item label="称呼" prop="contact_nickname">
            <el-input
              type="text"
              :maxlength="20"
              v-model="contactForm.contact_nickname"
              placeholder="我们应该如何称呼您？"
            ></el-input>
          </el-form-item>

          <el-form-item label="">
            <div class="m-btns">
              <el-button :disabled="saving" @click="setStep(-1)">上一步</el-button>
              <el-button type="primary" :loading="saving" @click="submitContactForm('contactForm')"
                >提交</el-button
              >
            </div>
          </el-form-item>
        </el-form>
      </section>
    </div>

    <Message :show.sync="showMessage" :text="messageText" />
  </div>
</template>

<script>
import HeaderTopbar from 'components/common/HeaderTopbar'
import Steps from 'components/common/Steps'
import Framework from './Framework'
import Message from 'components/common/Message'

import { getAreaData, postTrialApplyV2 } from '@/api/index.js'

export default {
  name: 'apply',
  components: { HeaderTopbar, Steps, Framework, Message },

  data() {
    return {
      step: 0,
      saving: false,

      schoolForm: {
        area_id: []
      },
      schoolRules: {
        school_name: [{ required: true, message: '请输入学校全称', trigger: 'change' }],
        school_type: [{ required: true, message: '请选择学校类型', trigger: 'change' }],
        school_student_num: [{ required: true, message: '请选择师生总人数', trigger: 'change' }],
        area_id: [{ required: true, message: '请选择学校所在地址', trigger: 'change' }],
        enable_test: [{ required: true, message: '是否配有专职心理教师', trigger: 'change' }],
        enable_consult: [{ required: true, message: '是否配有心理服务场地', trigger: 'change' }]
      },

      adminForm: {},
      adminRules: {
        admin_name: [{ required: true, message: '请输入账号名', trigger: 'change' }],
        admin_password: [
          { required: true, message: '请输入密码', trigger: 'change' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'change' }
        ],
        admin_phone: [
          { required: true, message: '请输入手机号', trigger: 'change' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'change' }
        ]
      },

      systemForm: {
        enable_roles: [],
        level: { g2019: 3, g2018: 0, g2017: 0, c2019: 3, c2018: 0, c2017: 0 }
      },
      systemRules: {
        enable_roles: [{ required: true, message: '请选择测评对象', trigger: 'change' }]
        /*channel_code: [
          { required: true, message: '请输入登录网址前缀', trigger: 'change' },
          {
            pattern: /^[a-zA-Z0-9]{2,20}$/,
            message: '请输入2至20位之间的英文/数字组合',
            trigger: 'change'
          }
        ]*/
      },

      contactForm: {},
      contactRules: {
        /*contact_phone: [
          { required: true, message: '请填写常用手机号', trigger: 'change' },
          { pattern: /^1\d{10}$/, message: '手机号格式不正确', trigger: 'change' }
        ],*/
        contact_nickname: [{ required: true, message: '我们应该如何称呼您？', trigger: 'change' }]
      },

      resultForm: {},

      // options
      schoolTypes: [
        {
          value: '幼儿园',
          label: '幼儿园'
        },
        {
          value: '小学',
          label: '小学'
        },
        {
          value: '初中',
          label: '初中'
        },
        {
          value: '高中',
          label: '高中'
        },
        {
          value: '九年一贯制',
          label: '九年一贯制'
        },
        {
          value: '初中高中',
          label: '初中高中'
        },
        {
          value: '十二年一贯制',
          label: '十二年一贯制'
        },
        {
          value: '中职中专',
          label: '中职中专'
        },
        {
          value: '高校',
          label: '高校'
        },
        {
          value: '其他',
          label: '其他'
        }
      ],
      schoolScale: [
        {
          value: '1~500人',
          label: '1~500人'
        },
        {
          value: '500~1000人',
          label: '500~1000人'
        },
        {
          value: '1000~2000人',
          label: '1000~2000人'
        },
        {
          value: '2000~4000人',
          label: '2000~4000人'
        },
        {
          value: '4000~8000人',
          label: '4000~8000人'
        },
        {
          value: '8000人以上',
          label: '8000人以上'
        }
      ],

      areaProps: {
        lazy: true,
        lazyLoad: this.areaLazyLoad
      },

      // message's tip
      showMessage: false,
      messageText: ''
    }
  },

  computed: {
    // 渠道归属机构code
    inviteChannelCode() {
      return this.$route.query['invite_channel_code']
    },
    // 商务code
    busCode() {
      return this.$route.query['cod']
    },
    // 模版code - 复制该渠道内容
    tplCode() {
      return this.$route.query['tplCod']
    }
  },

  methods: {
    setStep(flag) {
      this.step = this.step + flag
    },

    gotoBack() {
      window.history.back()
    },

    areaLazyLoad(node, resolve) {
      const { level, label, value } = node
      getAreaData(level === 0 ? 1 : value, 1)
        .then(res => {
          let areaList = res.data

          if (areaList.length === 0) {
            areaList = [
              {
                id: value,
                name: label
              }
            ]
          }
          const nodes = areaList.map(item => ({
            value: item.id,
            label: item.name,
            leaf: level >= 2
          }))
          resolve(nodes)
        })
        .catch(() => {})
    },

    submitSchoolForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) {
          return false
        }

        this.resultForm['school_name'] = this.schoolForm['school_name']
        this.resultForm['school_type'] = this.schoolForm['school_type']
        this.resultForm['school_student_num'] = this.schoolForm['school_student_num']
        this.resultForm['enable_services'] =
          this.schoolForm['enable_test'] || this.schoolForm['enable_consult']
            ? 'test,consult'
            : 'test'

        let len = this.schoolForm['area_id'].length
        this.resultForm['area_id'] = this.schoolForm['area_id'][len - 1]

        this.setStep(1)
      })
    },

    submitAdminForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) {
          return false
        }

        this.resultForm['admin_name'] = this.adminForm['admin_name']
        this.resultForm['admin_password'] = this.adminForm['admin_password']
        this.resultForm['admin_phone'] = this.adminForm['admin_phone']

        this.setStep(1)
      })
    },

    submitSystemForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) {
          return false
        }

        // 获取架构数据
        let levelData = this.$refs['framework'].getLevelData()

        this.resultForm['enable_roles'] = this.systemForm['enable_roles'].join(',')
        this.resultForm['channel_code'] = this.systemForm['channel_code']
        this.resultForm['level_json'] = levelData

        this.setStep(1)
      })
    },

    submitContactForm(formRef) {
      this.$refs[formRef].validate(valid => {
        if (!valid) {
          return false
        }

        this.resultForm['contact_phone'] = this.contactForm['contact_phone']
        this.resultForm['contact_nickname'] = this.contactForm['contact_nickname']

        this.saveFormData(this.resultForm)
      })
    },

    saveFormData(data) {
      if (this.saving) return

      this.saving = true
      postTrialApplyV2({
        ...data,
        inviteChannelCode: this.inviteChannelCode,
        businessCode: this.busCode,
        tplCode: this.tplCode
      })
        .then(() => {
          this.saving = false
          this.$router.push({
            name: 'trial.new.status',
            query: {
              flag: 'submit',
              invite_channel_code: this.inviteChannelCode,
              cod: this.busCode,
              tplCod: this.tplCode
            }
          })
        })
        .catch(error => {
          if (error.response && error.response.data.msg) {
            this.messageText = 'ERROR：' + error.response.data.msg
          } else {
            this.messageText = 'ERROR：提交失败，请检查申请表格信息，需要帮助请联系客服'
          }
          this.saving = false
          this.showMessage = true
        })
    }
  }
}
</script>

<style lang="scss">
.page-apply.dm-corp-page {
  padding-bottom: 20px;
  .m-container {
    padding-top: 60px;
  }
  .m-title {
    margin-bottom: 30px;
    text-align: center;
    font-size: 22px;
    font-weight: 600;
    line-height: 22px;
  }

  .m-step {
    margin: 0 auto 30px;
    max-width: 380px;
  }

  .m-form {
    margin: 0 auto 30px;
    max-width: 380px;

    .block {
      display: block;
    }

    .m-btns {
      padding-top: 10px;
      text-align: center;
      .el-button + .el-button {
        margin-left: 20px;
      }
    }

    .el-form-item__label {
      font-weight: bold;
      line-height: 22px;
    }

    .el-checkbox-group {
      line-height: 1.5;
    }

    .top-msg {
      padding: 10px;
      background: #edf3ff;
      border-radius: 4px;
      color: #1c67fe;
      line-height: 1.4;
      text-align: center;
    }

    .item-tip {
      color: #999;
      font-size: 12px;
    }

    .url-input {
      width: 160px;
      margin-right: 10px;
    }
  }

  .thank-item {
    text-align: center;
    line-height: 1.5;

    p {
      text-align: justify;
      line-height: 1.5;
    }
  }
}
</style>
